import { Link, useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image/withIEPolyfill"
import React from "react";
import { useLocation } from "@reach/router";
import * as style from "./Navigation.module.css";
import SA_logo from "../../images/SA_logo.js";

const OffCanvas = () => {
    const { pathname } = useLocation()
    return (
        <div id="offcanvas-nav-primary" className={`${style.mobileNav} uk-animation-fade uk-animation-fast`}
            data-uk-offcanvas="overlay: false; flip: false; mode: slide; selClose: .uk-close">
            <div className="uk-offcanvas-bar uk-flex uk-flex-column uk-flex-middle">
                <div className="uk-position-top-left uk-padding-small uk-padding-remove-horizontal uk-width-1-1 uk-grid uk-grid-collapse uk-flex uk-flex-middle">
                    <div className="uk-width-1-6">
                        <button
                            className="uk-margin-left"
                            type="button"
                            data-uk-icon="ratio: 1.5"
                            data-uk-close />
                    </div>
                    <div className={`${style.Logo} uk-logo`}>
                        <SA_logo color={"#ffffff"} />
                    </div>
                </div>
                <ul
                    className="uk-nav uk-nav-primary uk-margin-auto-vertical uk-text-left uk-width-5-6"
                    data-uk-nav>
                    {pathname !== "/" ?
                        <li className="uk-margin-xsmall"><Link className={`${pathname === "/" ? "uk-active" : ""}`} to={`/`}>Home</Link></li>
                        : null}
                    <li className="uk-margin-xsmall">
                        <Link className={`${pathname.includes("capabilities") ? "uk-active" : ""}`} to={`/capabilities/`}>Capabilities</Link>
                    </li>
                    <li
                        className={`uk-parent uk-margin-xsmall ${pathname.includes("contact") ? "uk-active uk-open" : ""}`}>
                        <Link className={`${pathname.includes("solutions") ? "uk-active" : ""}`} to={`/solutions/`}>Solutions</Link>
                        <ul className="uk-nav-sub">
                            <li>
                                <Link
                                    className={`uk-width-5-6 ${pathname.includes("performance") ? "uk-active" : "uk-text-blood-light"} ${pathname === "/profile" ? "uk-close" : ""}`}
                                    to={`/solutions/performance/`}>
                                    <div style={{ fontSize: "0.85em" }} className={`uk-flex uk-flex-middle uk-flex-between`}>Performance</div>
                                </Link>
                            </li>
                            <li>
                                <Link
                                    className={`uk-width-5-6 ${pathname.includes("brand-experience") ? "uk-active" : "uk-text-blood-light"} ${pathname === "/profile" ? "uk-close" : ""}`}
                                    to={`/solutions/brand-experience/`}>
                                    <div style={{ fontSize: "0.85em" }} className={`uk-flex uk-flex-middle uk-flex-between`}>Experience</div>
                                </Link>
                            </li>
                            <li>
                                <Link
                                    className={`uk-width-5-6 ${pathname.includes("rates") ? "uk-active" : "uk-text-blood-light"} ${pathname === "/rates" ? "uk-close" : ""}`}
                                    to={`/rates`}>
                                    <div style={{ fontSize: "0.85em" }} className={`uk-flex uk-flex-middle uk-flex-between`}>CX</div>
                                </Link>
                            </li>
                            <li>
                                <Link
                                    className={`uk-width-5-6 ${pathname.includes("contact") ? "uk-active" : "uk-text-blood-light"} ${pathname === "/contact" ? "uk-close" : ""}`}
                                    to={`/contact`}>
                                    <div style={{ fontSize: "0.85em" }} className={`uk-flex uk-flex-middle uk-flex-between`}>Data</div>
                                </Link>
                            </li>
                        </ul>
                    </li>
                    <li
                        className={`uk-parent uk-margin-xsmall ${pathname.includes("contact") ? "uk-active uk-open" : ""}`}>
                        <Link className={`${pathname.includes("insights") ? "uk-active" : ""}`} to={`/news-insights/`}>News & Insights</Link>

                        <ul className="uk-nav-sub">
                            <li>
                                <Link
                                    className={`uk-parent uk-width-5-6 ${pathname.includes("profile") ? "uk-active" : "uk-text-blood-light"} ${pathname === "/profile" ? "uk-close" : ""}`}
                                    to={`/profile`}>
                                    <div style={{ fontSize: "0.85em" }} className={`uk-flex uk-flex-middle uk-flex-between`}>Insights</div>
                                </Link>
                            </li>
                            <li>
                                <Link
                                    className={`uk-width-5-6 ${pathname.includes("rates") ? "uk-active" : "uk-text-blood-light"} ${pathname === "/rates" ? "uk-close" : ""}`}
                                    to={`/rates`}>
                                    <div style={{ fontSize: "0.85em" }} className={`uk-flex uk-flex-middle uk-flex-between`}>Articles</div>
                                </Link>
                            </li>
                            <li>
                                <Link
                                    className={`uk-width-5-6 ${pathname.includes("rates") ? "uk-active" : "uk-text-blood-light"} ${pathname === "/rates" ? "uk-close" : ""}`}
                                    to={`/rates`}>
                                    <div style={{ fontSize: "0.85em" }} className={`uk-flex uk-flex-middle uk-flex-between`}>Events</div>
                                </Link>
                            </li>
                        </ul>
                    </li>
                    <li
                        className={`uk-parent uk-margin-xsmall ${pathname.includes("contact") ? "uk-active uk-open" : ""}`}>
                        <Link className={`uk-parent ${pathname.includes("about") ? "uk-active uk-open" : ""}`} to={`/about-us/`}>About Us</Link>

                        <ul className="uk-nav-sub">
                            <li>
                                <Link
                                    className={`uk-width-5-6 ${pathname.includes("profile") ? "uk-active" : "uk-text-blood-light"} ${pathname === "/about-us/profile/" ? "uk-close" : ""}`}
                                    to={`/about-us/profile/`}>
                                    <div style={{ fontSize: "0.85em" }} className={`uk-flex uk-flex-middle uk-flex-between`}>Our Story</div>
                                </Link>
                            </li>
                            <li>
                                <Link
                                    className={`uk-width-5-6 ${pathname.includes("rates") ? "uk-active" : "uk-text-blood-light"} ${pathname === "/rates" ? "uk-close" : ""}`}
                                    to={`/rates`}>
                                    <div style={{ fontSize: "0.85em" }} className={`uk-flex uk-flex-middle uk-flex-between`}>Our Partners</div>
                                </Link>
                            </li>
                            <li>
                                <Link
                                    className={`uk-width-5-6 ${pathname.includes("rates") ? "uk-active" : "uk-text-blood-light"} ${pathname === "/rates" ? "uk-close" : ""}`}
                                    to={`/rates`}>
                                    <div style={{ fontSize: "0.85em" }} className={`uk-flex uk-flex-middle uk-flex-between`}>Join MC+A</div>
                                </Link>
                            </li>
                            <li>
                                <Link
                                    className={`uk-width-5-6 ${pathname.includes("contact") ? "uk-active" : "uk-text-blood-light"} ${pathname === "/contact" ? "uk-close" : ""}`}
                                    to={`/contact`}>
                                    <div style={{ fontSize: "0.85em" }} className={`uk-flex uk-flex-middle uk-flex-between`}>Get in touch</div>
                                </Link>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    )
}

const Navigation = ({ ...props }) => {
    const { pathname } = useLocation()

    const localImage = useStaticQuery(graphql`
    fragment localImage on File {
        childImageSharp {
            fluid(maxWidth: 600, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp
            }
        }
    }
    query {
        profile: file(relativePath: { eq: "cta/profile.png" }) {
            ...localImage
          }
          partners: file(relativePath: { eq: "cta/partners.png" }) {
            ...localImage
          }
          careers: file(relativePath: { eq: "cta/careers.png" }) {
            ...localImage
          }
          contact: file(relativePath: { eq: "cta/contact.png" }) {
            ...localImage
          }
          performance: file(relativePath: { eq: "cta/performance.png" }) {
            ...localImage
          }
          experience: file(relativePath: { eq: "cta/experience.png" }) {
            ...localImage
          }
          data: file(relativePath: { eq: "cta/data.png" }) {
            ...localImage
          }
          insights: file(relativePath: { eq: "cta/insights.png" }) {
            ...localImage
          }
          articles: file(relativePath: { eq: "cta/articles.png" }) {
            ...localImage
          }
          events: file(relativePath: { eq: "cta/events.png" }) {
            ...localImage
          }
          cx: file(relativePath: { eq: "cta/cx.png" }) {
            ...localImage
          }
    }
  `);

    return (
        <>
            <div className="uk-position-top">
                <div
                    className={`${style.nav} uk-background-white`}
                    data-uk-sticky="cls-active: uk-background-secondary uk-light uk-box-shadow-medium; top: 1vh; animation: uk-animation-fade">
                    <div className="uk-container">
                        <nav className="uk-container uk-navbar uk-navbar-container">
                            <div className="uk-navbar-left">
                                <button
                                    data-uk-toggle="target: #offcanvas-nav-primary"
                                    className="uk-button-text uk-navbar-toggle uk-navbar-item uk-margin-xsmall-right uk-hidden@m"
                                    data-uk-navbar-toggle-icon />
                                <div className="uk-navbar-item uk-padding-remove-horizontal">
                                    <Link className={`${style.Logo}`} to={`/`}>
                                        <SA_logo />
                                    </Link>
                                </div>
                            </div>

                            <div className="nav-overlay uk-navbar-right uk-flex-1" hidden>
                                <div className="uk-navbar-item uk-width-expand uk-margin-xsmall-left uk-margin-large-left uk-margin-xsmall-right">
                                    <form className="uk-search uk-search-navbar uk-width-1-1 uk-background-muted-light">
                                        <input className="uk-search-input" type="search" placeholder="Search" autoFocus={true} />
                                    </form>
                                </div>
                                <a className="uk-navbar-toggle" data-uk-close data-uk-toggle="target: .nav-overlay; animation: uk-animation-fade" href="#"></a>
                            </div>
                            <div className="nav-overlay uk-navbar-right">
                                <ul className="uk-navbar-nav uk-visible@m">
                                    <li className={`uk-text-bold uk-navbar-item ${pathname.includes("capabilities") ? "uk-active" : ""}`}>
                                        <Link to={`/capabilities`}>Capabilities</Link>
                                    </li>
                                    <li className={`uk-parent uk-text-bold uk-navbar-item ${pathname.includes("cases") ? "uk-active" : ""}`}>
                                        <Link to={`/solutions`}>Solutions</Link>
                                        <div
                                            style={{ width: "688px" }}
                                            className="uk-navbar-dropdown uk-padding-remove"
                                            data-uk-dropdown="offset: 20; pos: bottom-right">
                                            <div className="uk-nav uk-navbar-dropdown-nav uk-grid uk-grid-collapse uk-child-width-1-4">
                                                <Link to={'/solutions/performance/'}>
                                                    <div className="uk-padding-small uk-card uk-card-small">
                                                        <div className="uk-card-media-top uk-margin-xsmall-top">
                                                            <Img
                                                                fluid={localImage.performance.childImageSharp.fluid}
                                                                style={{ height: "96px" }}
                                                                alt="Performance."
                                                                objectFit="cover"
                                                                objectPosition="50% 50%"
                                                                loading="eager"
                                                            />
                                                        </div>
                                                        <div className="uk-card-body uk-padding-remove uk-margin-small">
                                                            <h5 className="uk-text-bold uk-margin-xsmall-bottom">Performance</h5>
                                                            <p className="uk-text-normal uk-margin-remove-top">Make your marketing matter more.</p>
                                                        </div>
                                                    </div>
                                                </Link>

                                                <Link className="" to={'/solutions/brand-experience/'}>
                                                    <div className="uk-padding-small uk-card uk-card-small">
                                                        <div className="uk-card-media-top uk-margin-xsmall-top">
                                                            <Img
                                                                fluid={localImage.experience.childImageSharp.fluid}
                                                                style={{ height: "96px" }}
                                                                alt="Brand experience."
                                                                objectFit="cover"
                                                                objectPosition="50% 50%"
                                                                loading="eager"
                                                            />
                                                        </div>
                                                        <div className="uk-card-body uk-padding-remove uk-margin-small">
                                                            <h5 className="uk-text-bold uk-margin-xsmall-bottom">Experience</h5>
                                                            <p className="uk-text-normal uk-margin-remove-top">Use your search data to build better brand experiences.</p>
                                                        </div>
                                                    </div>
                                                </Link>

                                                <Link className="" to={'/solutions/customer-experience/'}>
                                                    <div className="uk-padding-small uk-card uk-card-small">
                                                        <div className="uk-card-media-top uk-margin-xsmall-top">
                                                            <Img
                                                                fluid={localImage.cx.childImageSharp.fluid}
                                                                style={{ height: "96px" }}
                                                                alt="Customer experience."
                                                                objectFit="cover"
                                                                objectPosition="50% 50%"
                                                                loading="eager"
                                                            />
                                                        </div>
                                                        <div className="uk-card-body uk-padding-remove uk-margin-small">
                                                            <h5 className="uk-text-bold uk-margin-xsmall-bottom">CX</h5>
                                                            <p className="uk-text-normal uk-margin-remove-top">Drive more effective and efficient customer support.</p>
                                                        </div>
                                                    </div>
                                                </Link>

                                                <Link className="" to={'/solutions/data/'}>
                                                    <div className="uk-padding-small uk-card uk-card-small">
                                                        <div className="uk-card-media-top uk-margin-xsmall-top">
                                                            <Img
                                                                fluid={localImage.data.childImageSharp.fluid}
                                                                style={{ height: "96px" }}
                                                                alt="Data."
                                                                objectFit="cover"
                                                                objectPosition="50% 50%"
                                                                loading="eager"
                                                            />
                                                        </div>
                                                        <div className="uk-card-body uk-padding-remove uk-margin-small">
                                                            <h5 className="uk-text-bold uk-margin-xsmall-bottom">Data</h5>
                                                            <p className="uk-text-normal uk-margin-remove-top">Deliver actionable insights through search data.</p>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                    </li>
                                    <li className={`uk-text-bold uk-navbar-item ${pathname.includes("insights") ? "uk-active" : ""}`}>
                                        <Link to={`/news-insights/`}>News & Insights</Link>
                                        <div
                                            style={{ width: "512px" }}
                                            className="uk-navbar-dropdown uk-padding-remove"
                                            data-uk-dropdown="offset: 19; pos: bottom-right">
                                            <div className="uk-nav uk-navbar-dropdown-nav uk-grid uk-grid-collapse uk-child-width-1-3">
                                                <Link to={'/news-insights/insights/'}>
                                                    <div className="uk-padding-small uk-card uk-card-small">
                                                        <div className="uk-card-media-top uk-margin-xsmall-top">
                                                            <Img
                                                                fluid={localImage.insights.childImageSharp.fluid}
                                                                style={{ height: "96px" }}
                                                                alt="Insights."
                                                                objectFit="cover"
                                                                objectPosition="50% 50%"
                                                                loading="eager"
                                                            />
                                                        </div>
                                                        <div className="uk-card-body uk-padding-remove uk-margin-small">
                                                            <h5 className="uk-text-bold uk-margin-xsmall-bottom">Insights</h5>
                                                            <p className="uk-text-normal uk-margin-remove-top">Think pieces and thought starters.</p>
                                                        </div>
                                                    </div>
                                                </Link>

                                                <Link className="" to={'/news-insights/articles/'}>
                                                    <div className="uk-padding-small uk-card uk-card-small">
                                                        <div className="uk-card-media-top uk-margin-xsmall-top">
                                                            <Img
                                                                fluid={localImage.articles.childImageSharp.fluid}
                                                                style={{ height: "96px" }}
                                                                alt="Articles."
                                                                objectFit="cover"
                                                                objectPosition="50% 50%"
                                                                loading="eager"
                                                            />
                                                        </div>
                                                        <div className="uk-card-body uk-padding-remove uk-margin-small">
                                                            <h5 className="uk-text-bold uk-margin-xsmall-bottom">Articles</h5>
                                                            <p className="uk-text-normal uk-margin-remove-top">News updates and other reads.</p>
                                                        </div>
                                                    </div>
                                                </Link>

                                                <Link className="" to={'/news-insights/events/'}>
                                                    <div className="uk-padding-small uk-card uk-card-small">
                                                        <div className="uk-card-media-top uk-margin-xsmall-top">
                                                            <Img
                                                                fluid={localImage.events.childImageSharp.fluid}
                                                                style={{ height: "96px" }}
                                                                alt="Events."
                                                                objectFit="cover"
                                                                objectPosition="50% 50%"
                                                                loading="eager"
                                                            />
                                                        </div>
                                                        <div className="uk-card-body uk-padding-remove uk-margin-small">
                                                            <h5 className="uk-text-bold uk-margin-xsmall-bottom">Events</h5>
                                                            <p className="uk-text-normal uk-margin-remove-top">Join our next event or watch a recording of one you missed.</p>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                    </li>
                                    <li className={`uk-parent uk-text-bold uk-navbar-item ${pathname.includes("about") ? "uk-active uk-open" : ""}`}>
                                        <Link to={`/about-us/`}>About Us</Link>
                                        <div
                                            style={{ width: "688px" }}
                                            className="uk-navbar-dropdown uk-padding-remove"
                                            data-uk-dropdown="offset: 19; pos: bottom-right">
                                            <div className="uk-nav uk-navbar-dropdown-nav uk-grid uk-grid-collapse uk-child-width-1-4">
                                                <Link to={'/about-us/profile/'}>
                                                    <div className="uk-padding-small uk-card uk-card-small">
                                                        <div className="uk-card-media-top uk-margin-xsmall-top">
                                                            <Img
                                                                fluid={localImage.profile.childImageSharp.fluid}
                                                                style={{ height: "96px" }}
                                                                alt="Out company"
                                                                objectFit="cover"
                                                                objectPosition="50% 50%"
                                                                loading="eager"
                                                            />
                                                        </div>
                                                        <div className="uk-card-body uk-padding-remove uk-margin-small">
                                                            <h5 className="uk-text-bold uk-margin-xsmall-bottom">Our Story</h5>
                                                            <p className="uk-text-normal uk-margin-remove-top">We're the experts for everything search.</p>
                                                        </div>
                                                    </div>
                                                </Link>
                                                <Link className="" to={'/about-us/partners/'}>
                                                    <div className="uk-padding-small uk-card uk-card-small">
                                                        <div className="uk-card-media-top uk-margin-xsmall-top">
                                                            <Img
                                                                fluid={localImage.partners.childImageSharp.fluid}
                                                                style={{ height: "96px" }}
                                                                alt="Our partners."
                                                                objectFit="cover"
                                                                objectPosition="50% 50%"
                                                                loading="eager"
                                                            />
                                                        </div>
                                                        <div className="uk-card-body uk-padding-remove uk-margin-small">
                                                            <h5 className="uk-text-bold uk-margin-xsmall-bottom">Our Partners</h5>
                                                            <p className="uk-text-normal uk-margin-remove-top">A preferred partner to the industry's leading technology platforms.</p>
                                                        </div>
                                                    </div>
                                                </Link>

                                                <Link className="" to={'/about-us/careers/'}>
                                                    <div className="uk-padding-small uk-card uk-card-small">
                                                        <div className="uk-card-media-top uk-margin-xsmall-top">
                                                            <Img
                                                                fluid={localImage.careers.childImageSharp.fluid}
                                                                style={{ height: "96px" }}
                                                                alt="Join MC+A."
                                                                objectFit="cover"
                                                                objectPosition="50% 50%"
                                                                loading="eager"
                                                            />
                                                        </div>
                                                        <div className="uk-card-body uk-padding-remove uk-margin-small">
                                                            <h5 className="uk-text-bold uk-margin-xsmall-bottom">Join MC+A</h5>
                                                            <p className="uk-text-normal uk-margin-remove-top">Join search's strongest advocates and guardians.</p>
                                                        </div>
                                                    </div>
                                                </Link>

                                                <Link className="" to={'/about-us/contact/'}>
                                                    <div className="uk-padding-small uk-card uk-card-small">
                                                        <div className="uk-card-media-top uk-margin-xsmall-top">
                                                            <Img
                                                                fluid={localImage.contact.childImageSharp.fluid}
                                                                style={{ height: "96px" }}
                                                                alt="Contact us."
                                                                objectFit="cover"
                                                                objectPosition="50% 50%"
                                                                loading="eager"
                                                            />
                                                        </div>
                                                        <div className="uk-card-body uk-padding-remove uk-margin-small">
                                                            <h5 className="uk-text-bold uk-margin-xsmall-bottom">Get in Touch</h5>
                                                            <p className="uk-text-normal uk-margin-remove-top">Contact us to discuss your next project or our ongoing management services.</p>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <div className="uk-margin-left">
                                    <a className="uk-navbar-toggle" data-uk-search-icon data-uk-toggle="target: .nav-overlay; animation: uk-animation-fade" href="#"></a>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
            <OffCanvas />
        </>
    )
}

export default Navigation;
